var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.5,
    r: 16.5,
    fill: "#FAA42A",
    stroke: "#FAA42A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2828 18.2795C16.8494 18.2795 16.4336 18.1075 16.1265 17.8011L10.863 12.5293C10.9842 12.2258 11.1933 11.9656 11.4634 11.7822C11.7334 11.5988 12.0522 11.5005 12.3785 11.5H22.1871C22.5135 11.5005 22.8322 11.5988 23.1022 11.7822C23.3723 11.9656 23.5814 12.2258 23.7026 12.5293L18.4391 17.8011C18.132 18.1075 17.7162 18.2795 17.2828 18.2795ZM17.2819 19.3693C18.0044 19.3693 18.6975 19.0827 19.209 18.5723L23.8217 13.9608V23.5H10.7422V13.9608L15.3549 18.5723C15.8664 19.0827 16.5594 19.3693 17.2819 19.3693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.715c5fd387b9174b4ae6a07e33bd3f0f.svg";
export { ForwardRef as ReactComponent };